import React from "react";
import { Link } from "@/components/common/Link";
const markers = [{
  label: "Escursioni",
  path: "/HikesAndSoundsPage"
}, {
  label: "Memoria",
  path: "/StoriesOfAlpiniPage"
}, {
  label: "Video",
  path: "#"
}, {
  label: "Galleria",
  path: "#"
}, {
  label: "Chi Sono",
  path: "#"
}, {
  label: "Foto",
  path: "#"
}, {
  label: "Contatti",
  path: "#"
}];
export default function HandpanInteractiveNavigationHub() {
  return <section id="handpaninteractivenavigationhub" className="relative flex min-h-[100svh] w-full items-center justify-center overflow-hidden bg-background py-24">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="h-[50vw] w-[50vw] rounded-full bg-primary/5 blur-[120px]" />
      </div>

      <div className="relative mx-auto flex aspect-square w-[320px] items-center justify-center sm:w-[400px] md:w-[500px] lg:w-[600px]">
        {}
        <div className="absolute inset-0" style={{
        animation: "spin 45s linear infinite"
      }}>
          {}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="relative flex h-[65%] w-[65%] items-center justify-center rounded-full bg-transparent shadow-none transition-transform duration-700 hover:scale-105">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648136/img/handpansfondonero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648136/img/handpansfondonero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648136/img/handpansfondonero.png-wvc-sizes" alt="Handpan Instrument" className="h-full w-full rounded-full object-cover bg-transparent border-0 shadow-none" loading="lazy" />
            </div>
          </div>

          {}
          {markers.map((marker, i) => {
          const angle = 360 / markers.length * i;
          return <div key={i} data-index={i} className="absolute inset-0" style={{
            transform: `rotate(${angle}deg)`
          }}>
                {}
                <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2">
                  {}
                  <div style={{
                transform: `rotate(-${angle}deg)`
              }}>
                    {}
                    <div style={{
                  animation: "spin 45s linear infinite reverse"
                }}>
                      <Link to={marker.path} className="group flex h-16 w-16 items-center justify-center rounded-full border border-primary/50 bg-card text-center shadow-lg transition-all duration-300 hover:scale-110 hover:border-primary hover:bg-primary hover:shadow-[0_0_20px_var(--color-primary)] sm:h-20 sm:w-20 md:h-24 md:w-24">
                        <span className="font-default text-xs font-medium tracking-wider text-foreground transition-colors duration-300 group-hover:text-primary-foreground sm:text-sm md:text-base">
                          {marker.label}
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>

      {}
      <div className="pointer-events-none absolute left-8 top-8 h-24 w-24 border-l border-t border-primary/20" />
      <div className="pointer-events-none absolute bottom-8 right-8 h-24 w-24 border-b border-r border-primary/20" />
    </section>;
}